<div style="display: flex;margin-bottom: 8px;background-color: #fff;padding: 25px 0px;" class="title">

    <div style="flex-grow: 9;font-size: 18px;">
      <h6   [class]="fromAccont?'address-title accout':'address-title'"> {{'ADDRESS.ADDRESS' | translate}}</h6>
    </div>
    <div style="flex-grow: 1;">
      <button type="button" data-toggle="modal" data-target="#address-add" class="add-new-btn" (click)="resetForm()">{{'ADDRESS.ADD_NEW' | translate}}</button>
    </div>
  </div>
  <div class="profile-address-book">
    <ul class="address-list" [ngClass]="fromAccont ? 'margin-left-right-30' : ''">
      <li [class]="address.id == selectedadreses?.id ? 'active':''" *ngFor="let address of adresess;let i=index;"
        [ngStyle]="{'display': showaddress ? 'flex' :( address.id == selectedadreses?.id?'flex':'none') }">
        <div style="margin: 10px;">

          <!-- <button type="button" *ngIf="!fromAccont && address.id != selectedadreses?.id" class="here-btn"
            (click)="selectAddress(address)">
            Deliver here
          </button> -->
        </div>
        <div class="address-text">
          <h6  *ngIf="address.addressType==1">{{'ADDRESS.HOME' | translate}} <span *ngIf="address.isdefault">(default) &nbsp;&nbsp; <span class="icon" *ngIf="address.isdefault"><i class="fas fa-check-circle"></i></span> </span> </h6>
          <h6 *ngIf="address.addressType==2">{{'ADDRESS.OFFICE' | translate}} <span *ngIf="address.isdefault">(default)&nbsp;&nbsp;<span class="icon" *ngIf="address.isdefault"><i class="fas fa-check-circle"></i></span></span> </h6>
          <h6 *ngIf="address.addressType==3"> {{'ADDRESS.OTHER' | translate}} <span *ngIf="address.isdefault">(default)&nbsp;&nbsp;<span class="icon" *ngIf="address.isdefault"><i class="fas fa-check-circle"></i></span></span> </h6>


          <p class="address">
            {{address.houseNo}} {{address.appartmentName}} {{address.streetDetails}}
            {{address.niknameAddress}}
            {{address.landmark}}
          </p>
          <p class="country">{{address.areaName}},{{address.city}},{{address.mobileNo}}</p>
        </div>
        <div class="edit-delete-btn">
          <button class="edit" type="button" data-toggle="modal" data-target="#address-add"
            (click)="editAddress(address)"><i class="fas fa-edit"></i></button>
          <button class="delete" *ngIf="address.id != selectedadreses?.id" (click)="deleteAddresh(address.id)"><i
              class="fas fa-trash-alt"></i></button>
        </div>
      </li>

    </ul>
    <div class="text-right" *ngIf="adresess.length>1" [ngClass]="fromAccont ? 'padding-right-15' : ''">
      <a> <span class="show-more" *ngIf="!showaddress" (click)="showaddress=!showaddress"> {{'ADDRESS.Show' | translate}}</span></a>
      <a> <span class="show-more" *ngIf="showaddress" (click)="showaddress=!showaddress"> {{'ADDRESS.Minimize' | translate}}</span></a>
    </div>
  </div>

   <div class="modal fade address-edit-box" id="address-add" tabindex="-1" aria-labelledby="address-add"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <h4>{{"ADDRESS.ADD_YOUR_ADDRESS" | translate}}</h4>
          <form action="#" class="address-form" [formGroup]="addreshForm">
            <div class="row">

              <div class="col-lg-6">
                <div class="input-item ">
                  <label>{{"ADDRESS.ADDRESS_FOR" | translate}}</label><br>
                  <div class="row">

                    <div class="col-lg-4">
                      <button type="button" (click)="selectType(1)"
                        [class]="addressTypeId==1? 'btn btn-add-type active-add':'btn btn-add-type'">{{"ADDRESS.HOME" | translate}}</button>
                    </div>
                    <div class="col-lg-4">
                      <button type="button" (click)="selectType(2)"
                        [class]="addressTypeId==2 ?'btn btn-add-type active-add':'btn btn-add-type'"> {{"ADDRESS.OFFICE" | translate}}</button>
                    </div>
                    <div class="col-lg-4">
                      <button type="button" (click)="selectType(3)"
                        [class]="addressTypeId==3 ?'btn btn-add-type active-add':'btn btn-add-type'">{{"ADDRESS.OTHER" | translate}}</button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-item">
                  <label class="form-check-label" for="flexCheckDefault" >
                    {{"ADDRESS.MAKE_DEFAULT" | translate}}
                  </label>

                  <!-- <div class="input-with-check">
                    <input type="text" class="input-box" placeholder="Enter something">
                    <span class="check-icon">&#10004;</span>
                </div> -->

                  <div class="input-with-check">
                    <input formControlName="isDefault" (change)="onSelectDefaultAddress($event)" class="form-check-input largerCheckbox" type="checkbox" title="Select Checkbox" style="width: 1%;
                    margin-left: 7%;border: 1px solid black;cursor: pointer;">
                  <span class="check-icon">&#10004;</span>
                </div>
                </div>
              </div>

              <div class="col-lg-6">
                <div class="input-item">
                  <label>{{"ADDRESS.HOUSE_NO" | translate}}</label>
                  <input type="text" name="name" placeholder="{{'ADDRESS.HOUSE_NO' | translate}}" formControlName="houseNo" class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.houseNo.errors }">
                  <div *ngIf="submitted && f.houseNo.errors" class="invalid-feedback">
                    <div *ngIf="f.houseNo.errors.required">{{"ADDRESS.ERROR.HOUSE_NO_REQUIRED" | translate}}</div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-item">
                  <label>{{"ADDRESS.APPARTMENT_NO" | translate}}</label>
                  <input type="text" name="name" formControlName="appartment" placeholder="{{'ADDRESS.APPARTMENT_NO' | translate}}"
                    class="form-control" [ngClass]="{ 'is-invalid': submitted && f.appartment.errors }">
                  <div *ngIf="submitted && f.appartment.errors" class="invalid-feedback">
                    <div *ngIf="f.appartment.errors.required">{{"ADDRESS.ERROR.APARTMENT_IS_REQUIRED" | translate}}</div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-item">
                  <label>{{"ADDRESS.STREET_DETAILS" | translate}}</label>
                  <input type="text" name="name" placeholder="{{'ADDRESS.STREET_DETAILS' | translate}}" formControlName="streetDetails"
                    class="form-control" [ngClass]="{ 'is-invalid': submitted && f.streetDetails.errors }">
                  <div *ngIf="submitted && f.streetDetails.errors" class="invalid-feedback">
                    <div *ngIf="f.streetDetails.errors.required">{{"ADDRESS.ERROR.STREET_DETAIL_REQUIRED" | translate}}</div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-item">
                  <label>{{"ADDRESS.LANDMARK" | translate}}</label>
                  <input type="text" name="name" placeholder="{{'ADDRESS.LANDMARK' | translate}}" formControlName="landmark" class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.landmark.errors }">
                  <div *ngIf="submitted && f.landmark.errors" class="invalid-feedback">
                    <div *ngIf="f.landmark.errors.required">{{"ADDRESS.ERROR.LANDMARK_IS_REQUIRED" | translate}}</div>
                  </div>
                </div>
              </div>

              <div class="col-lg-6">
                <div class="input-item">
                  <label>{{"ADDRESS.ZIP" | translate}}</label>
                  <input type="text" name="name" placeholder="{{'ADDRESS.ZIP' | translate}}" formControlName="pincode" maxlength="6"
                    (keyup)="GetAreaListByPincode($event.target.value)" class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.pincode.errors }">
                  <div *ngIf="submitted && f.pincode.errors" class="invalid-feedback">
                    <div *ngIf="f.pincode.errors.required">{{"ADDRESS.ERROR.ZIP_REQUIRED" | translate}}</div>
                  </div>
                </div>

                <!-- <div class="input-item">
                  <label>{{"ADDRESS.ZIP" | translate}}</label>
                  <input type="text" name="name" placeholder="{{'ADDRESS.ZIP' | translate}}" formControlName="postcode" maxlength="6"
                    (keyup)="filterAreaByPincode($event.target.value)" class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.postcode.errors }" >
                  <div *ngIf="submitted && f.postcode.errors" class="invalid-feedback">
                    <div *ngIf="f.postcode.errors.required">{{"ADDRESS.ERROR.ZIP_REQUIRED" | translate}}</div>
                  </div>
                </div> -->
              </div>

              <div class="col-lg-6">
                <div class="input-item">
                  <label>{{"ADDRESS.CITY" | translate}}</label>
                  <!-- <div class="select">
                    <select formControlName="cityId" class="form-control"
                      (change)="getAreaListByCity($event.target.value)"
                      [ngClass]="{ 'is-invalid': submitted && f.cityId.errors }">
                      <option value="">Select</option>
                      <option *ngFor="let city of cityList" [value]="city.id"> {{city.cityNameEng}}</option>
                    </select>
                    <div *ngIf="submitted && f.cityId.errors" class="invalid-feedback">
                      <div *ngIf="f.cityId.errors.required">{{"ADDRESS.ERROR.SELECT_CITY" | translate}}</div>
                    </div>
                  </div> -->
                  <input type="text" name="city" placeholder="{{'ADDRESS.CITY' | translate}}" [(ngModel)]="city"  formControlName="city" class="form-control"
                  [ngClass]="{ 'is-invalid': submitted && f.city.errors }" disabled>


                <div *ngIf="submitted && f.city.errors" class="invalid-feedback">
                  <div *ngIf="f.city.errors.required">{{"ADDRESS.ERROR.SELECT_CITY" | translate}}</div>
                </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group input-item">
                  <label>{{"ADDRESS.AREA"
                     | translate}}</label>
                  <div class="select">
                    <select formControlName="area" class="form-control"
                      [ngClass]="{ 'is-invalid': submitted && f.area.errors }">
                      <option value="0" selected >Select</option>
                     <!-- <option *ngFor="let area of postcodeListofSelectedPinCode" [value]="area.id"> {{area.areaNameEng}}</option> -->
                      <option  *ngFor="let area of postcodeList" [value]="area"> {{ area }}</option>
                    </select>
                    <div *ngIf="submitted && f.area.errors" class="invalid-feedback">
                      <div *ngIf="f.area.errors.required">{{"ADDRESS.ERROR.SELECT_AREA" | translate}}</div>
                    </div>
                  </div>

                  <!-- <input type="text" name="area" placeholder="{{'ADDRESS.AREA' | translate}}" formControlName="area" class="form-control"
                  [ngClass]="{ 'is-invalid': submitted && f.area.errors }">
                <div *ngIf="submitted && f.area.errors" class="invalid-feedback">
                  <div *ngIf="f.area.errors.required">{{"ADDRESS.ERROR.SELECT_AREA" | translate}}</div>
                </div> -->

                </div>

              </div>
              <div class="col-lg-6">
                <div class="input-item">
                  <label>{{"ADDRESS.CONTACT_NO" | translate}}</label>
                  <input type="text" name="name" minlength="10" maxlength="10" placeholder="{{'ADDRESS.CONTACT_NO' | translate}}" formControlName="mobileNo" class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.mobileNo.errors }" (keypress)="isNumber($event)">
                  <div *ngIf="submitted && f.mobileNo.errors" class="invalid-feedback">
                    <div *ngIf="f.mobileNo.errors.required">{{"ADDRESS.ERROR.MOBILE_REQUIRED" | translate}}</div>
                  </div>
                </div>
              </div>

            </div>
            <div class="row col-sm-12">
              <div class="col-sm-9">
                <button class="submit" (click)="addNewAddress()" [disabled]="saveloader">
                  <i class="fa fa-spinner fa-spin" *ngIf="saveloader"></i>
                  {{"ADDRESS.SAVE" | translate}}</button>
              </div>
              <div class="col-sm-1">
                <button data-dismiss="modal" id="cancelmodel" class="cancel" (click)="resetForm()">{{"ADDRESS.CANCEL" | translate}}</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
